import styled from "styled-components";
import { SideMenuComponentBox } from "../../side-menu/boxes/side-menu-component.box";

export const ProfileWrapperBox = styled(SideMenuComponentBox)`
    margin: 4rem 0 0 0;
`;
